// @ts-nocheck
import React from 'react'
import { Route, IndexRoute } from 'react-router'
import auth from '../auth'
import api from '../api'

import Dashboard from '../components/dashboard'
import Wrapper from '../components/wrapper'
import Login from '../components/login'
import Logout from '../components/logout'
import Layout from '../components/layout'

import WriteNowRoutes from './write-now'
import SecurityRoutes from './security'
import MembershipRoutes from './membership'
import CmsRoutes from './cms'
import EventRoutes from './event'
import SettingsRoutes from './settings'
import AdminAuditRoutes from './admin-audit'
import MediaRoutes from './media'
import EcommerceRoutes from './ecommerce'
import ReportRoutes from './reports'
import ResetPassword from '../components/reset-password'

const requireAuth = (nextState, replace, callback) => {
  const reject = () => {
    auth.clearToken()
    replace('/login')
  }

  auth.refresh(ok => {
    if (!ok) {
      reject()
      return callback()
    }

    api.get('v2/users/current')
      .then(res => res.json())
      .then(user => {
        if (!user.roles || user.roles.indexOf('admin') === -1) {
          reject()
        }
        callback()
      })
      .catch(() => {
        reject()
        callback()
      })
  })
}

const Four04 = () => (
  <div>
    <h3>Invalid URL</h3>
    <a href='/'>return home</a>
  </div>
)

const AppRoutes = (
  <Route path='/' component={Wrapper}>
    <Route path='login' component={Login} />
    <Route path='reset-password' component={ResetPassword} />
    <Route component={Layout} onEnter={requireAuth}>
      <Route path='logout' component={Logout} />
      <IndexRoute component={Dashboard} />
      {WriteNowRoutes}
      {SecurityRoutes}
      {MembershipRoutes}
      {CmsRoutes}
      {EventRoutes}
      {EcommerceRoutes}
      {SettingsRoutes}
      {AdminAuditRoutes}
      {MediaRoutes}
      {ReportRoutes}
    </Route>
    <Route path='*' exact component={Four04} />
  </Route>
)

export default AppRoutes
